import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

const SuccessModal = ({ onClose }) => {
  const navigate = useNavigate();

  const handleModalClose = () => {
    onClose();
    navigate("/account/fs-dashboard/work-timesheets");
  };

  return (
    <div className="agreement-success-modal-overlay">
      <div className="agreement-success-modal-content">
        <FontAwesomeIcon
          icon={faCheckCircle}
          className="agreement-modal-success-icon"
        />
        <h2>Success!</h2>
        <p>Claim status has been updated successfully.</p>
        <button
          className="agreement-modal-close-button"
          onClick={handleModalClose}
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default SuccessModal;
